unless window.gs?
  window.gs = {}

gs = window.gs

class TreeNode
  constructor: (@id, @parent)->
    @name_const = ko.observable null
    @pk = ko.observable null
    @s = ko.observable null # Sensor Input Types (i.e 'watts')
    @combination = ko.observable null

    @children = ko.observableArray [] # Sub-nodes
    if @parent?
      @units = @parent.units
      @rounding = @parent.rounding
    else
      @units = "watts"
      @rounding = 1

    @single_sensor = ko.computed gs.common.defer =>
      return @children().length <= 1

    # Sensors on the current level
    @sensors = ko.computed gs.common.defer =>
      if @children().length > 0
        for subtree in @children()
          subtree
      else
        return [@]

    @parent_sensor = ko.computed =>
      return @

    # Each parent in the heirarachy leading to this sensor, starting with the topmost ancescestor, then getting closer to this device.
    @parent_sensors = ko.computed =>
      curr_node = @

      parents = []
      while curr_node?
        parents.push curr_node
        curr_node = curr_node.parent

      parents.reverse()
      return parents

    @color = ko.computed =>
      path = @id
      idx = parseInt(path[path.length-1])
      return gs.colors[idx]

    @url_root = ko.computed gs.common.defer =>
      gs.bindings?.url_for_node @

    @name = ko.computed => @get_name()

    @curr = ko.computed gs.common.defer =>
        return null

#        return null unless gs.bindings
#        our_data = gs.bindings.data_mgr.get_live_data([@])[0]
#
#        if our_data.length == 0
#          return undefined
#
#        return our_data[our_data.length - 1][1]
#        # TODO: Calculate running averages, etc.

    @curr_rounded = ko.computed gs.common.defer =>
      # TODO: Thousands seperator
      return if not @curr()?

      "" + @curr().toFixed(@rounding)

    @curr_str = ko.computed gs.common.defer =>
        # TODO: Thousands seperator
        return if not @curr()?
        val = @curr_rounded()
        val += " " + @units
        return val


  get_name: ->
    name = @name_const()
    return name if name? and name != ""

    return "No Name Set #{@id}"

  select: ->
    if not @ in gs.bindings.selected
      gs.bindings.selected.push(@)

  deselect: =>
    if @ in gs.bindings.selected
      gs.bindings.selected.remove(@)

  load: (data)->
    if data['name']
      @name_const ko.utils.unwrapObservable data['name']
    else
      @name_const null

    if data['s']
      @s ko.toJS data['s']
      watt_pk = @s()['watts']
      if watt_pk?
        @pk watt_pk
    else
      new_pk = ko.utils.unwrapObservable data['pk']
      @pk new_pk
      if new_pk?
        @s {'watts': new_pk}

    if data['comb']
      @combination ko.utils.unwrapObservable data['comb']
    else
      @combination 'sum'

    children = []
    if data['sub']
      sub =  ko.utils.unwrapObservable data['sub']
      for own idx, child of sub
        new_id = "#{@id}/#{idx}"
        node = new TreeNode(new_id, @)
        node.load(child)
        children.push(node)

    @children children

  save: ->
    data = {}
    if @name_const()
      data['name'] = @name_const()
    if @s()?
      data['s'] = @s()
    if @combination & @combination != "sum"
      data['comb'] = @combination()

    sub = []
    for own idx, child of @children()
      sub.push(child.save())

    if sub.length > 0
      data['sub'] = sub

    return data

  set_root: ->
    gs.router.navigate @url_root()

  render_lists: ->
    rendered = render_tree_lists(@)
    return spread_tree_lists(rendered)

  set_parent_to: (new_parent) ->
    old_parent = @parent

    if new_parent == old_parent
      return

    if old_parent?
      new_children = old_parent.children()
      for idx, child_node of new_children
        if @ == child_node
          new_children.splice(idx, 1)
      old_parent.children new_children

    if new_parent?
      new_children = new_parent.children()
      new_children.push(@)
      new_parent.children new_children

    @parent = new_parent


class NodeCursor
  constructor: (@tree_name, @sensor_tree, node) ->
    @node = ko.observable node
    @structured_units = ko.computed => gs.structured_units @node()

  select: (new_node) =>
    @node new_node

  get_path: -> @node().id

  select_path: (path) =>
    found_node = @sensor_tree.find path
    if found_node and found_node != @node()
      @node found_node
      return true
    else
      console?.log "Couldn't find node with path", path
      return false

class SensorTree
  constructor: ()->
    @root = ko.observable new TreeNode("0", null)
    @curr_tree = ko.computed => @save()
    @curr_tree.extend
      throttle:500

  load: (data) ->  @root().load(data)
  save: -> @root().save()

  find: (path, separator = "/") ->

    #allow path to begin with
    path = path.substring(1)  if path[0] is separator
    indexes = path.split(separator)
    index = null
    context = @root()
    return null unless context?
    i = 1 # Ignore first 0
    while i < indexes.length
      index = parseInt(indexes[i], 10)
      context = (if (context.children().length and context.children().length > index) then context.children()[index] else null)
      i++

    return context

render_tree_lists = (root_node, test_mode = false) ->
  # Render the tree as a series of lists, where each list represents a tree depth
  # List of active nodes, along with the depth of that node in the tree. The list contains the
  #  Node, parent and level in the tree.

  active = [[root_node, null, 0]]
  lists = []

  while active.length > 0
    [node, parent, level] = active.pop()
    if level >= lists.length
      lists.push([])
    level_nodes = lists[level]

    if test_mode
      level_nodes.push({'node':node.name_const(), 'parent':parent, 'children':[]})
    else
      level_nodes.push({'node':node, 'parent':parent, 'children':[]})

    our_idx = level_nodes.length - 1
    if parent?
      parent_node = lists[level-1][parent]
      parent_node.children.push(our_idx)

    reversed = node.children().slice(0).reverse()
    for child in reversed
      active.push([child, our_idx, level+1])

  return lists

spread_tree_lists = (tree_lists) ->
  # Takes the tree lists as output by render_tree_lists and adds a vertical spread parameter.

  for col_num in [tree_lists.length-1 .. 0] by -1
    lst = tree_lists[col_num]
    sibling_pos = null
    for node_num in [lst.length-1 .. 0] by -1
      node = lst[node_num]

      v_pos = node_num

      switch node.children.length
        when 0
          if sibling_pos?
            v_pos = sibling_pos - 1
          else
            v_pos = node_num
            if tree_lists[col_num + 1]?.length > v_pos
              v_pos = tree_lists[col_num + 1].length
        when 1
          v_pos = tree_lists[col_num + 1][node.children[0]].v_pos
        else
          child_min = tree_lists[col_num + 1][node.children[0]].v_pos
          child_max = tree_lists[col_num + 1][node.children[node.children.length - 1]].v_pos
          v_pos = Math.floor((child_min + child_max) / 2)

      v_pos = Math.max(v_pos, node_num) # Leave room for nodes above us
      if sibling_pos?
        v_pos = Math.min(v_pos, sibling_pos - 1)
        node['v_space'] = sibling_pos - v_pos - 1 # Number of empty slots below this node.
      else
        node['v_space'] = 0

      sibling_pos = v_pos

      node['v_pos'] = v_pos
      for child_idx in node.children
        tree_lists[col_num + 1][child_idx]['v_pos_parent'] = v_pos


  return tree_lists

# -------- Power Maths -------
phaseAngle = (real, img) ->
    # Ported from Python...
    if (real > 0)     # 0 to 90 degrees or 270 to 360 degrees.
        if (img > 0)    #0 to 90 degrees (0 to pi/2)
            return Math.atan(img/real)
        else            # 270 to 360 degrees
            if (img == 0)
                return  0    # Return 0 rather than 360 degrees
            return (6.283185307 - Math.atan(-img/real))
    else  # 90 to 270 degrees
        if (img > 0)    #90 to 180 degrees (pi/2 to pi)
            if (real == 0)
                return 1.570796327    # 90 degrees
            return ((Math.PI - Math.atan(img/-real)))
        else            # 180 to 270 degrees
            if (real == 0)
                return 4.71238898    # 270 degrees
            return (Math.PI + Math.atan(img/real));

pfCalc = (angleWRTphaseNumber) ->
    # Ported from Python...
    # Put phase in range the range of -90 to 270
    regen = false

    # If load is regenerating then adjust angles so standard calculations below can be used.
    if (angleWRTphaseNumber > 1.570796327) # Load is regeneration
        regen = true # Outside +/- 90 degrees
        angleWRTphaseNumber = 3.141592654 - angleWRTphaseNumber # Adjust angle so PF can be calculated below.

    # Standard calculations.
    if (angleWRTphaseNumber < 0) # Leading PF. i.e. -ve
        return -Math.cos(angleWRTphaseNumber)
    else  # Lagging PF. i.e.+ve
        return Math.cos(angleWRTphaseNumber)

calc_PF = (real, img) ->
    # 10 VA deadzone for PF calculations...
    return 1 unless (real * real) + (img * img) > (10*10)

    readAngle = phaseAngle(real,img) #get angle in radians before adding offset
    if (readAngle > 6.283185307)
      readAngle -=  6.283185307

    return pfCalc(readAngle) #Also sets up regen

angle_deg = (real, img) ->
    angle_rad = phaseAngle(real, img)
    return angle_rad * (180.0 / Math.PI)

# --------

wrap_child_ops = (child, ops) ->
  unless ops? and (not ops.isArray or ops.length > 0)
    null
  else if child.combination() == "none"
    null # Ignore input
  else if child.combination() == "sub"
    ['-',ops]
  else
    ops

maths_ops = (tree, unit='watts', opt={}) ->
  pre_calc = tree.s()?[unit]
  if pre_calc?
    return pre_calc

  if unit == 'PF' and gs.has_unit(tree, 'watts') and gs.has_unit(tree, 'img')
    return ['gs.calc_PF',
     wrap_child_ops(tree, maths_ops(tree, 'watts', opt)),
     wrap_child_ops(tree, maths_ops(tree, 'img', opt))]

  direct_ops = []
  conv_nodes = []

  for child in tree.children()
    c_pre_calc = child.s()?[unit]
    if c_pre_calc?
      direct_ops.push wrap_child_ops(child, c_pre_calc)
    else
      conv_nodes.push child

  if conv_nodes.length == 0
    return null unless direct_ops.length > 0
    return direct_ops[0] unless direct_ops.length > 1
    return ['+'].concat(direct_ops)
  else
    watt_ops = for child in conv_nodes
      if gs.has_unit(child, unit)
        child_ops = maths_ops(child, unit, opt)
        continue unless child_ops?
        wrap_child_ops child, child_ops
      else
        continue

    all_ops = direct_ops.concat(watt_ops)
    return null unless all_ops
    return all_ops[0] if all_ops.length == 1
    ['+'].concat(all_ops)

#  else if not opt['no_conv'] and unit == 'PF'
#    if gs.has_unit(tree, 'watts') and gs.has_unit(tree, 'img')
#      return ['gs.calc_PF', maths_ops(tree, 'watts', opt), maths_ops(tree, 'img', opt)]
#    else
#      return null
#  else
#    out = ['+3']
#    for child in tree.children()
#      result = maths_ops(child, unit, opt)
#      if result?
#        out.push wrap_child_ops(child, result)
#
#    if out.length > 1
#      return out
#    else
#      return null

child_ops = (tree, unit) ->
  basic = for child in tree.children()
    maths_ops child, unit

#  if basic.length > 0 and tree.pk()?
#    # Add another trace that finds the difference between the base value and the sum of
#    #  the other traces.
#    basic.push ['-', tree.pk(), ['+'].concat(basic)]

  return basic

build_func_inner = (node) ->
  if $.isArray(node)
    op = node[0]
    child_calcs = []
    child_vars = []
    for idx in [1..node.length-1]
      continue unless node[idx]?
      [calcs, vars] = build_func_inner(node[idx])
      child_calcs.push(calcs)
      child_vars.push(vars)

    vars = $.extend {}, child_vars...

    switch op
      when "+", "-", "*", "/"
        # eg in_1 + in_2
        if op == "-" and child_calcs.length == 1
          # Negate a value when it's put in - by itself.
          return ["-#{child_calcs[0]}", vars]

        inner_str = child_calcs.join(" #{op} ")
        return ["(#{inner_str})", vars]
      else
        # eg conv_watts(in_1, in_2)
        return ["#{op}(#{child_calcs.join(', ')})", vars]
  else
    # Return a reference to the variable "in_2" say and a dict containing that as the single variable referenced.
    var_name = "in_#{node}"
    vars = {}
    vars[var_name] = node
    return [var_name, vars]

func_prefix = (inner_calcs) ->
  prefix = ""
  if ~inner_calcs.indexOf('gs.')
    prefix += "var gs = window.gs;\n"
  return prefix

build_func = (ops) ->
  [inner_calcs, vars] = build_func_inner(ops)
  labels = []
  pks = []
  for own label, pk of vars
    labels.push(label)
    pks.push(pk)

  prefix = func_prefix(inner_calcs)

  return [new Function(labels..., "#{prefix}return #{inner_calcs};"), pks]

get_min_length = (arrays...) ->
  if arrays.length == 0
    return 0

  min_len = arrays[0].length

  for array in arrays[1..]
    array_len = array.length
    if min_len > array_len
      min_len = array_len

  return min_len

build_array_func = (ops) ->
  [inner_calcs, vars] = build_func_inner(ops)
  labels = []
  pks = []
  var_mapping = []
  for own label, pk of vars
    labels.push("#{label}_a")
    pks.push(pk)
    var_mapping.push("var #{label} = #{label}_a[i];")

  prefix = func_prefix(inner_calcs)

  first_arg = labels[0]
  func_body = """
          #{prefix}
          var array_len = gs.get_min_length.apply(null, arguments);
          var ret_arr = new Array(array_len);
          for (var i = 0; i < array_len; ++i){
            #{var_mapping.join('\n')}
            ret_arr[i] = #{inner_calcs};
          }
          return ret_arr;
          """

  #console?.log ops, inner_calcs, vars
  #console?.log func_body

  return [new Function(labels..., func_body), pks]


zip = (args...)->
  # Thanks http://stackoverflow.com/a/10284006/11440
  longest = args.reduce((a, b) ->
    (if a.length > b.length then a else b)
  , [])
  longest.map (_, i) ->
    args.map (array) ->
      array[i]

has_null = (data) ->
  for sample in data
    unless sample?
      return true
  return false

apply_func = (kernel, data) ->
  result_array = []
  for day_samples in zip(data...)
    # day_samples is an array containing the data for one day from each sensor

    result_array.push(kernel(day_samples...))

  return [].concat(result_array...)

units_in_tree = (tree)->
  stats = {}
  for child in tree.children()
    child_stats = units_in_tree(child)
    for own key of child_stats
      val = stats[key] or 0
      stats[key] = val + 1

  for own key of tree.s()
    val = stats[key] or 0
    stats[key] = val + 1

  return stats

has_unit = (tree, unit)->
  return true if tree.s()?[unit]?

  for child in tree.children()
    if has_unit(child, unit)
      return true

  if unit == "PF"
    return true if has_unit(tree, 'watts') and has_unit(tree, 'img')

  return false

structured_units = (tree)->
  units = gs.units_in_tree(tree)

  result = []

  if not units['PF']? and units['watts']? and units['img']?
    units['PF'] = 0 # Add this derived input...

  for own unit of units
    unit_nodes = []
    for child in tree.children()
      if gs.has_unit(child, unit)
        unit_nodes.push(child)

    if tree.s()?[unit]?
      unit_nodes.push(tree)
    else if unit == 'PF' and tree.s()?['watts']? and tree.s()?['img']?
      unit_nodes.push(tree)

    result.push
      unit: unit
      nodes: unit_nodes

  return result

gs.TreeNode = TreeNode
gs.NodeCursor = NodeCursor
gs.SensorTree = SensorTree

gs.maths_ops = maths_ops
gs.child_ops = child_ops
gs.render_tree_lists = render_tree_lists
gs.spread_tree_lists = spread_tree_lists
gs.build_func_inner = build_func_inner
gs.build_func = build_func
gs.build_array_func = build_array_func

gs.apply_func = apply_func
gs.zip = zip
gs.get_min_length = get_min_length
gs.units_in_tree = units_in_tree
gs.has_unit = has_unit
gs.structured_units = structured_units

gs.calc_PF = calc_PF
gs.angle_deg = angle_deg
